import type { Observable, Subscription } from 'rxjs'

export const passAsync =
  (cdObservables: Observable<any>[], subscription: Subscription) =>
  <T>(source$: Observable<T>, callback: (val: T) => void) => {
    cdObservables.push(source$)
    subscription.add(source$.subscribe(callback))
  }
